export const LIVE_TYPE = {
  NORMAL: Symbol('NORMAL'),
  EVENT: Symbol('EVENT'),
  FUN_CLUB: Symbol('FUN_CLUB'),
  PAID: Symbol('PAID'),
}